<template>
  <v-app>
      <!-- <NavBar /> -->
    <v-main>
      <router-view />
    </v-main>
    <!-- <br>
    <br> -->
    <!-- <br>
    <br> -->
    <Footer v-if="path != '/Home' && path != '/og/finish'"/>
    <!-- <Footer2 v-if="path == '/og/finish'"/> -->
  </v-app>
</template>

<script>
// import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
// import Footer2 from "@/components/Footer2.vue";
// import FooterMigrations from "@/components/FooterMigrations.vue";

export default {
  components: {
    Footer,
    // Footer2,
    // FooterMigrations,
    // NavBar
  },
  data: () => ({
    path: null,
  }),
  mounted() {
    this.path = window.location.pathname;
  }
};
</script>